import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SearchInput from "../common/SearchInput";
import FunctionButton from "../common/FunctionButton";

/*
  로그인 카드 안에 붙는 인라인 OTP 인증 영역.

  화면은 입력 형식 1차 확인과 잔여 시간 표시만 담당한다.
  단계 전환은 서버 응답으로만 결정하며 화면이 스스로 바꾸지 않는다.
*/

const InlineWrap = styled.div`
  width: 526px;
  margin: 0 auto 18px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
  text-align: left;

  .otp_title {
    font-size: 13px;
    font-weight: bold;
    color: #002c5f;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .otp_timer {
    font-size: 12px;
    font-weight: normal;
    color: #888;
  }

  .otp_row {
    display: flex;
    gap: 6px;
    align-items: stretch;
  }

  /* 입력한 코드는 크게 유지하되 안내 문구만 작게 줄여 잘리지 않도록 한다. */
  .otp_row input::placeholder {
    font-size: 12px;
    letter-spacing: 1px;
  }

  .otp_reregister {
    margin-top: 10px;
    text-align: right;
  }

  .otp_reregister button {
    border: 0;
    background: none;
    color: #1560c8;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
  }

  .otp_reregister button:hover {
    text-decoration: underline;
  }

  .otp_message {
    min-height: 18px;
    margin-top: 10px;
    font-size: 13px;
    color: #c62828;
  }
`;

const formatRemain = (seconds) => {
  const safe = Math.max(0, seconds);
  const min = String(Math.floor(safe / 60)).padStart(2, "0");
  const sec = String(safe % 60).padStart(2, "0");

  return `${min}:${sec}`;
};

const OtpAuthInline = ({
  code,
  onCodeChange,
  onVerify,
  onCancel,
  onReRegister,
  remainSeconds,
  message,
}) => {
  const { t } = useTranslation();

  const activeEnter = (e) => {
    if (e.key === "Enter") {
      onVerify();
    }
  };

  return (
    <InlineWrap>
      <div className="otp_title">
        <span>{t("L1123")}</span>
        <span className="otp_timer">
          {t("L1122")} {formatRemain(remainSeconds)}
        </span>
      </div>

      <div className="otp_row">
        <SearchInput
          value={code}
          width="100%"
          maxLength={6}
          placeholder={t("L1121")}
          style={{
            height: "40px",
            backgroundColor: "#fff",
            border: "1px solid #002c5f",
            fontSize: "15px",
            letterSpacing: "3px",
          }}
          onChange={onCodeChange}
          onKeyDown={activeEnter}
          inputMode="numeric"
          autoFocus
        ></SearchInput>
        <FunctionButton
          className="small"
          value={t("L1125")}
          style={{ height: "40px", minWidth: "100px" }}
          onClick={onVerify}
        ></FunctionButton>
        <FunctionButton
          className="small bg_gray"
          value={t("L0005")}
          style={{ height: "40px", minWidth: "100px" }}
          onClick={onCancel}
        ></FunctionButton>
      </div>

      <div className="otp_reregister">
        <button type="button" onClick={onReRegister}>
          {t("L1128")} &nbsp;&gt;
        </button>
      </div>

      <div className="otp_message">{message}</div>
    </InlineWrap>
  );
};

export default OtpAuthInline;
